import { useCountUp } from '../hooks/useCountUp';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

interface AnimatedCounterProps {
  value: number;
  label: string;
  suffix?: string;
  duration?: number;
  inactiveValue?: number;
}

export const AnimatedCounter = ({ 
  value, 
  label, 
  suffix = '', 
  duration = 3000,
  inactiveValue
}: AnimatedCounterProps) => {
  const { current } = useCountUp(value, duration);
  const { current: inactiveCurrent } = useCountUp(inactiveValue || 0, duration);

  return (
    <TooltipProvider>
      <div className="text-center">
        <div className="text-4xl font-bold text-white mb-2 drop-shadow-lg">
          {current.toLocaleString()}
          {inactiveValue !== undefined && (
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="text-red-400/70 text-3xl cursor-help">
                  /{inactiveCurrent.toLocaleString()}
                </span>
              </TooltipTrigger>
              <TooltipContent>
                <p>Inactive {label.toLowerCase().replace('active ', '')}</p>
              </TooltipContent>
            </Tooltip>
          )}
          {suffix}
        </div>
        <div className="text-sm text-white font-medium drop-shadow-md">
          {label}
        </div>
      </div>
    </TooltipProvider>
  );
};